import { combineReducers } from "redux";
import orderItems from './order-items';

export default combineReducers({ orderItems });
